module.exports = __webpack_public_path__ + "static/img/portfolio_bg5.ccfb7a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_bg-portfolio/portfolio_bg5.png
// module id = 2E4w
// module chunks = 1